export const TABS = [
  { label: 'Payments', value: 'payments', link: 'payments' },
  { label: 'Claims', value: 'claims', link: 'claims' },
  { label: 'Financial Reporting', value: 'financial', link: 'financial' }
];
